export enum UserType {
  SuperAdmin = 1,
  Admin = 2,
  Practitioner = 3,
  Professional = 4,
  Patient = 5,
  Receptionist=6
}
export enum RoleUserType {
  Admin = 2,
  Practitioner = 3,
  Professional = 4,
  Patient = 5,
  Receptionist=6
}
export enum FileDirectoryPath {
  PatientDir = 'PTDocs',
  PatientIdentityDir = 'IdentityDocs',
  PatientVisitDocs = 'VisitDocs',
  PatientRefDocs = 'RefDocs',
  ReferralDocs = 'ReferralDocs',
  AppDocsDir = 'AppDocs',
  TaskDocsDir = 'TaskDocs',
  InvestigationResultDocs = 'InvestigationResultDocs',
  OtherDocs = 'OtherDocs',
  EmailDocsDir = 'EmailDocs',
  CorrespondenceDir = 'CorrespondenceDocs',
  PatientInsuranceDir = 'InsuranceDocs',
  ProfilePhoto = 'ProfilePhoto',
  PatientEducationDocs = 'PatientEducationDocs'
}

export enum AnswerType {
  Single_Value = 1,
  Multi_Value = 2,
  Text = 3,
  Date = 4,
}

export enum LabType {
  Lab = 1,
  Imaging = 2,
}

export enum EmailRefType {
  VisitNote = 'VisitNote',
}

export enum PaymentModeType {
  UPI = 1,
  Offline = 2,
}

export enum DocumentRefType {
  VisitNoteTemplate = 'VisitNoteTemplate',
  ReportTemplate = 'ReportTemplate',
  EmailTemplate = 'EmailTemplate',
  PatientVisit = 'PatientVisit',
  PatientPrescription = 'PatientPrescription',
  PatientInvoice = 'PatientInvoice',
  PatientInvestigationOrder = 'PatientInvestigationOrder',
  PatientReferral = 'PatientReferral',
}

export enum AttachmentRefType {
  EmailTemplateAttechment = 1,
  Task = 2,
  EmailAttechment = 3,
  PatientDocs = 4,
}

export enum NotificationRefType {
  AppointmentReminder = 'Appointment Reminder',
  AppointmentConfirmationReminder = 'Appointment Confirmation Reminder',
  PendingTask = 'Pending Task',
}

export enum RoomType {
  General_Ward = 1,
  ICU = 2,
  Operating_Theatre = 3,
  Consultation_Room = 4,
  Emergency_Room = 5,
  Recovery_Room = 6
}

export enum Department {
  Cardiology = 1,
  Orthopedics = 2,
  Pediatrics = 3,
  General_Medicine = 4,
  Emergency = 5,
  Surgery = 6,
  Radiology = 7
}

export enum InterventionType {
  'Pharmacological' = 1601,
  'Non-Pharmacological' = 1602,
  'Lifestyle Modification' = 1603,
  'Patient Education' = 1604,
}

export enum PatientEducationContentType {
  Video = 1,
  Image = 2,
  PDF = 3,
  Word = 4,
  Excel = 5,
  External_Link = 6,
}

